<mat-nav-list class="list-horizontal">
  <mat-list-item [routerLink]="['/tours']" [routerLinkActive]="['active']">
    <a>Touren</a>
  </mat-list-item>
  <mat-list-item [routerLink]="['/customers']" [routerLinkActive]="['active']">
    <a>Baustellen</a>
  </mat-list-item>
  <mat-list-item [routerLink]="['/drivers']" [routerLinkActive]="['active']">
    <a>Personal</a>
  </mat-list-item>
  <mat-list-item [routerLink]="['/vehicles']" [routerLinkActive]="['active']">
    <a>Fuhrpark</a>
  </mat-list-item>
  <mat-list-item [routerLink]="['/users']" [routerLinkActive]="['active']">
    <a>Benutzer</a>
  </mat-list-item>
  <mat-list-item *ngxPermissionsOnly="['ROLE_SUPER_ADMIN']" [routerLink]="['/departments']" [routerLinkActive]="['active']">
    <a>Abteilungen</a>
  </mat-list-item>
</mat-nav-list>
